import { useCallback, useEffect, useRef, useState } from "react";
import { fetchStockNewsQuestions } from "../api/stockNewsQuestions";

/**
 * Load daily news analysis questions for Stock Management tab label and panel.
 */
export function useStockNewsQuestions({ accountId, serverUrl, stockSession, enabled = true }) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const inflightRef = useRef(null);
  const loadedAccountRef = useRef("");

  const reloadQuestions = useCallback(async () => {
    if (!accountId || !enabled) return [];
    if (inflightRef.current) return inflightRef.current;

    inflightRef.current = (async () => {
      setLoading(true);
      try {
        const rows = await fetchStockNewsQuestions(serverUrl, stockSession);
        setQuestions(rows);
        return rows;
      } catch {
        setQuestions([]);
        return [];
      } finally {
        setLoading(false);
        inflightRef.current = null;
      }
    })();

    return inflightRef.current;
  }, [accountId, enabled, serverUrl, stockSession]);

  useEffect(() => {
    if (!accountId || !enabled) {
      setQuestions([]);
      loadedAccountRef.current = "";
      return;
    }
    if (loadedAccountRef.current === accountId) return;
    loadedAccountRef.current = accountId;
    reloadQuestions();
  }, [accountId, enabled, reloadQuestions]);

  return {
    questions,
    setQuestions,
    count: questions.length,
    loading,
    reloadQuestions,
  };
}
